
import { defineComponent } from 'vue';
import router, { propertyBaseRouter } from '@/router';

export default defineComponent({
    setup() {
        router.push(`/${propertyBaseRouter}`);
    }
});
